/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { DeleteConversationMutationResponse, DeleteConversationPathParams, DeleteConversation401, DeleteConversation500 } from "../../types/chatController/DeleteConversation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getDeleteConversationUrl(organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/chat/conversations/${conversationId}` as const }
  return res
}

/**
 * @summary Archive (soft-delete) a conversation
 * {@link /api/organizations/:organizationId/chat/conversations/:conversationId}
 */
export async function deleteConversation(organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, unknown>({ method : "DELETE", url : getDeleteConversationUrl(organizationId, conversationId).url.toString(), ... requestConfig })
  return res.data
}